import React, { Component } from "react";
import PropTypes from "prop-types";

import CookieConsent from "react-cookie-consent";
import ReactPiwik from "react-piwik";
import i18n from "i18n-react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { SearchProvider } from "hooks/useSearch";

import {
  WelcomeView,
  LoginView,
  NotFoundView,
  SubRouter,
  PrintComponent,
  ScrollToTop,
} from "C4";
import { demo, piwikSiteid } from "settings";

const hashLinkScroll = () => {
  const { hash } = window.location;
  if (hash !== "") {
    setTimeout(() => {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) element.scrollIntoView();
    }, 0);
  }
};

function cookieExists(cookieName) {
  const decodedCookies = decodeURIComponent(document.cookie);
  const splitCookies = decodedCookies.split(";");
  return splitCookies.includes(cookieName);
}

export default class AppRouter extends Component {
  constructor(props) {
    super(props);

    const piwik = new ReactPiwik({
      url: "//data.travpromobile.com/matomo/",
      siteId: piwikSiteid,
      trackErrors: true,
    });
    ReactPiwik.push(["requireConsent"]);
    ReactPiwik.push(["trackPageView"]);

    this.state = {
      cookies: "",
    };

    this.CookieDecline = this.CookieDecline.bind(this);
    this.CookieAccept = this.CookieAccept.bind(this);
    this.showCookieBar = this.showCookieBar.bind(this);
  }

  componentWillMount() {
    if (
      cookieExists("cookieConsent=true") ||
      cookieExists(" cookieConsent=true")
    ) {
      this.setState({ cookies: "accepted" });
      ReactPiwik.push(["rememberConsentGiven"]);
    } else if (
      cookieExists("cookieConsent=false") ||
      cookieExists(" cookieConsent=false")
    ) {
      ReactPiwik.push(["forgetConsentGiven"]);
    } else {
      this.showCookieBar();
    }
  }

  showCookieBar() {
    this.setState({ cookies: "requiresConsent" });
  }

  CookieAccept() {
    this.setState({ cookies: "accepted" });
    ReactPiwik.push(["rememberConsentGiven"]);
    window.location.reload();
  }

  CookieDecline() {
    this.setState({ cookies: "declined" });
    ReactPiwik.push(["forgetConsentGiven"]);
    document.cookie = "cookieConsent=false";
    window.location.reload();
  }

  render() {
    return (
      <BrowserRouter
        onUpdate={(e) => {
          hashLinkScroll(e);
        }}
        history={() => this.piwik.connectToHistory(History)}
      >
        <SearchProvider>
          <ScrollToTop>
            <div className="container">
              <Switch>
                <Route path="/" exact render={() => <Redirect to="/login" />} />
                <Route path="/main" render={() => <SubRouter />} />
                <Route
                  path="/print/:firstName/:lastName/:appId"
                  render={(props) => {
                    const { firstName, lastName, appId } = props.match.params;
                    return (
                      <PrintComponent
                        firstName={firstName}
                        lastName={lastName}
                        appId={appId}
                      />
                    );
                  }}
                />
                <Route path="/welcome" exact render={() => <WelcomeView />} />
                <Route
                  path="/login"
                  render={(props) => <LoginView match={props.match} />}
                />
                <Route
                  path="/register"
                  exact
                  render={(props) => (
                    <LoginView match={props.match} keepUserStorage />
                  )}
                />
                <Route
                  path="/register-mobile"
                  exact
                  render={(props) => <LoginView match={props.match} />}
                />
                <Route
                  path="/forgot"
                  exact
                  render={(props) => <LoginView match={props.match} />}
                />
                <Route
                  path="/logout"
                  render={(props) => <LoginView match={props.match} />}
                />
                <Route component={NotFoundView} />
              </Switch>
              {this.state.cookies === "requiresConsent" && (
                <CookieConsent
                  location="top"
                  onAccept={this.CookieAccept}
                  buttonText={i18n.translate("cookies.consent")}
                  cookieName="cookieConsent"
                  expires={365}
                  containerClasses="cookieConsent"
                  contentClasses="cookieContent"
                  buttonClasses="cookieBtn"
                  debug
                  disableStyles
                >
                  <p className="cookieText">
                    <span>
                      <FontAwesomeIcon icon={["fas", "shield-alt"]} />
                    </span>
                    {i18n.translate("cookies.message")}
                  </p>
                  <button
                    onClick={this.CookieDecline}
                    className="cookieOptOut btnInverse"
                  >
                    {i18n.translate("cookies.optout")}
                  </button>
                </CookieConsent>
              )}
              {demo && (
                <CookieConsent
                  location="bottom"
                  buttonText={i18n.translate("demo.consent")}
                  cookieName="demoConsent"
                  expires={365}
                  containerClasses="demoConsent"
                  contentClasses="cookieContent"
                  buttonClasses="demoBtn"
                  debug
                  disableStyles
                >
                  <p className="cookieText">
                    <span>
                      <FontAwesomeIcon icon={["fas", "bug"]} />
                    </span>
                    {i18n.translate("demo.message")}
                  </p>
                </CookieConsent>
              )}
            </div>
          </ScrollToTop>
        </SearchProvider>
      </BrowserRouter>
    );
  }
}

AppRouter.propTypes = {
  match: PropTypes.shape(),
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

AppRouter.defaultProps = {
  match: {},
  location: {},
};
